import { render, staticRenderFns } from "./Son_Select.vue?vue&type=template&id=4f1ee087&scoped=true&"
import script from "./Son_Select.vue?vue&type=script&lang=js&"
export * from "./Son_Select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ee087",
  null
  
)

export default component.exports